import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { STATS } from 'routes'
import { media } from '../device'
import { Button } from '../button/button'
import { FeaturedStats } from '../featured-stats/featured-stats'

const STATS_PRO = `${process.env.REACT_APP_BETA_VERSION_URL}/meu-desempenho`

const StatsMigrationNotice = ({ showFeaturedStats = true, showCurrentVersionButton = true }) => {
  return (
    <PrincipalCard>
      <Title>Estamos melhorando suas estatísticas <span role='img' aria-label='chart increasing'>📊</span></Title>
      <InfoText>
        O novo menu de estatísticas está sendo liberado de forma gradual na versão PRO.
        Durante esse período, algumas informações podem aparecer incompletas ou ser atualizadas aos poucos, enquanto realizamos a migração dos dados.
        Em breve, a área de estatísticas da versão PRO oferecerá uma experiência ainda mais completa para acompanhar sua evolução.
      </InfoText>
      <InfoText>
        <b>Importante:</b> na versão PRO, seus dados passaram a ser contabilizados a partir de 01/01/2025. Por isso, seu ranking e seu total de acertos foram recalculados considerando esse período.
      </InfoText>
      {showFeaturedStats && <FeaturedStats />}
      <Content>
        {showCurrentVersionButton && <Button to={STATS}>Ver Estatísticas nessa versão</Button>}
        <Button
          as='a'
          href={STATS_PRO}
          variant='ghost'
        >
          Ver Estatísticas na PRO
        </Button>
      </Content>
    </PrincipalCard>
  )
}

export { StatsMigrationNotice }

StatsMigrationNotice.propTypes = {
  showFeaturedStats: PropTypes.bool,
  showCurrentVersionButton: PropTypes.bool,
}

const PrincipalCard = styled.div`
  background: ${({ theme }) => theme.darkTheme ? theme.colours.mainBackground : theme.colours.background};
  padding: 2.2rem;
  border-radius: ${({ theme }) => theme.radius.medium};
  width: 100%;
`

const Content = styled.div`
  padding-top: 2rem;
  display: flex;
  gap: 1rem;
`

const Title = styled.h1`
  font-size: 1.8rem;
  color: ${({ theme }) => theme.darkTheme ? theme.colours.text : theme.colours.text};

  ${media.lessThan('mediumDesktop')`
    font-size: 2.2rem;
  `}
`

const InfoText = styled.p`
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 1.3rem;
  color: ${({ theme }) => theme.darkTheme ? theme.colours.text : theme.colours.text};

  ${media.lessThan('mediumDesktop')`
    font-size: 1.2rem;
  `}
`
